import { render, staticRenderFns } from "./IndexNav.vue?vue&type=template&id=14d2e629&scoped=true&lang=pug&"
import script from "./IndexNav.vue?vue&type=script&lang=js&"
export * from "./IndexNav.vue?vue&type=script&lang=js&"
import style0 from "./IndexNav.vue?vue&type=style&index=0&id=14d2e629&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d2e629",
  null
  
)

export default component.exports